import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { provideConfig } from '@spartacus/core'
import { MbHomepageSearchBoxComponent } from './components/mb-homepage-search-box/mb-homepage-search-box.component'
import { MbSearchBoxModule } from '../shared/components/mb-search-box/mb-search-box.module'
import { MbHomepageFacetsAdapter } from './connectors'
import { MbOccHomepageFacetsAdapter } from './adapters'
import { SafeHtmlModule } from '../cms/pipes/sanitize-html/safe-html.module'
import { MbI18nModule } from '../translations/mb-i18n.module'
import { SpinnerModule } from '@spartacus/storefront'

@NgModule({
  declarations: [
    MbHomepageSearchBoxComponent
  ],
  imports: [
    MbSearchBoxModule,
    CommonModule,
    MbI18nModule,
    SafeHtmlModule,
    SpinnerModule
  ],
  providers: [
    {
      provide: MbHomepageFacetsAdapter,
      useExisting: MbOccHomepageFacetsAdapter,
    },
    provideConfig({
      cmsComponents: {
        MiltenyiHomepageSearchBoxComponent: {
          component: MbHomepageSearchBoxComponent
        }
      }
    })
  ]
})
export class HomepageModule {
}
